<script setup lang="ts">
import { type Component, onMounted, onBeforeUnmount } from 'vue';
import { QuizAudioKey } from '../../../../types/quiz';
import { useQuizStore } from '../../../../stores';
import { audioManager } from '../../../../utils/audioManager';
import { AssessmentQuestion } from '../../../../types/assessment';

import QuizFillInBlank from './patterns/QuizFillInBlank.vue';
import QuizMutipleChoice from './patterns/QuizMutipleChoice.vue';
import Slide from '../../../Animation/Slide.vue';

import quizOngoing from '../../../../assets/audios/quiz_ongoing.mp3'
import quizOngoing2 from '../../../../assets/audios/quiz_ongoing2.mp3'
import quizOngoing3 from '../../../../assets/audios/quiz_ongoing3.mp3'
import quizOngoing4 from '../../../../assets/audios/quiz_ongoing4.mp3'

interface IComponents {
    [key: string]: Component
}
const components: IComponents = {
    'mca': QuizMutipleChoice,
    'sca': QuizMutipleChoice,
    'gap': QuizFillInBlank
}
const { question, disabled } = defineProps<{
    question: AssessmentQuestion
    disabled?: boolean
}>()

const quizStore = useQuizStore()

onMounted(() => {
    const srcList = [quizOngoing, quizOngoing2, quizOngoing3, quizOngoing4]
    audioManager.playIndex(srcList, quizStore.curentQuestionIndex % srcList.length, QuizAudioKey.BGM, { loop: true, volume: quizStore.bgmVolumeState.volume, muted: quizStore.bgmVolumeState.muted })
})

onBeforeUnmount(() => {
    audioManager.stop(QuizAudioKey.BGM)
})

</script>
<template>
    <Slide :direction="'left'">
        <component :is="components[question.questionType as keyof typeof components]" :question="question" :key="question.id" :disabled="disabled"></component>
    </Slide>
</template>